/**
 * Presence API client — who is online right now.
 *
 * Heartbeat + polling rather than a socket (see backend/src/routes/presence.ts
 * for why). The read is global: one list of user ids that every consumer
 * intersects with whatever people it renders.
 */
import { apiFetch } from './api';
import { useAuthStore } from '../store/useAuthStore';

interface Envelope<T> {
  success: true;
  data: T;
}

function authHeaders(): Record<string, string> {
  const token = useAuthStore.getState().accessToken;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/** Report that this tab is awake. Answers 204, so there is nothing to read. */
export async function sendHeartbeat(): Promise<void> {
  await apiFetch<void>('/api/presence/heartbeat', { method: 'POST', headers: authHeaders() });
}

export async function fetchOnlineUserIds(): Promise<string[]> {
  const res = await apiFetch<Envelope<{ onlineUserIds: string[] }>>('/api/presence', {
    headers: authHeaders(),
  });
  return res.data?.onlineUserIds ?? [];
}
